/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snackbar_Namealreadyexists2Inputs */

const en_snackbar_namealreadyexists2 = /** @type {(inputs: Snackbar_Namealreadyexists2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An item with this name already exists.`)
};

const de_snackbar_namealreadyexists2 = /** @type {(inputs: Snackbar_Namealreadyexists2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Eintrag mit diesem Namen existiert bereits.`)
};

/**
* | output |
* | --- |
* | "An item with this name already exists." |
*
* @param {Snackbar_Namealreadyexists2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const snackbar_namealreadyexists2 = /** @type {((inputs?: Snackbar_Namealreadyexists2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snackbar_Namealreadyexists2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_snackbar_namealreadyexists2(inputs)
	return de_snackbar_namealreadyexists2(inputs)
});
export { snackbar_namealreadyexists2 as "snackbar_nameAlreadyExists" }